import { amaClear, amaStore, amaUpdateBlockContent, amaUpdateIsActive, amaUpdateIsLoading, selectAmaBlockContent, selectAmaId } from '@store/slices/blocks/ama/amaSlice.js';
import {
  appointmentClear,
  appointmentStore,
  appointmentUpdateBlockContent,
  appointmentUpdateBlockDesign,
  appointmentUpdateBlockSettings,
  appointmentUpdateIsActive,
  appointmentUpdateIsLoading,
  selectAppointmentBlockContent,
  selectAppointmentBlockDesign,
  selectAppointmentId,
  selectAppointmentUID,
} from '@store/slices/blocks/appointment/appointmentSlice.js';
import {
  appsClear,
  appsStore,
  appsUpdateBlockContent,
  appsUpdateBlockDesign,
  appsUpdateIsActive,
  appsUpdateIsLoading,
  selectAppsBlockContent,
  selectAppsBlockDesign,
  selectAppsId,
  selectAppsUID,
} from '@store/slices/blocks/apps/appsSlice.js';
import {
  audioInboxClear,
  audioInboxStore,
  audioInboxUpdateBlockContent,
  audioInboxUpdateIsActive,
  audioInboxUpdateIsLoading,
  selectAudioInboxBlockContent,
  selectAudioInboxId,
} from '@store/slices/blocks/audioInbox/audioInboxSlice.js';
import {
  bannerClear,
  bannerStore,
  bannerUpdateBlockContent,
  bannerUpdateBlockDesign,
  bannerUpdateIsActive,
  bannerUpdateIsLoading,
  selectBannerBlockContent,
  selectBannerId,
} from '@store/slices/blocks/banner/bannerSlice.js';
import {
  blogClear,
  blogStore,
  blogUpdateBlockContent,
  blogUpdateBlockDesign,
  blogUpdateIsActive,
  blogUpdateIsLoading,
  selectBlogBlockContent,
  selectBlogBlockDesign,
  selectBlogId,
  selectBlogUID,
} from '@store/slices/blocks/blog/blogSlice.js';
import {
  communityClear,
  communityStore,
  communityUpdateBlockContent,
  communityUpdateBlockDesign,
  communityUpdateIsActive,
  communityUpdateIsLoading,
  selectCommunityBlockContent,
  selectCommunityBlockDesign,
  selectCommunityId,
  selectCommunityUID,
} from '@store/slices/blocks/community/communitySlice.js';
import {
  contactsClear,
  contactsStore,
  contactsUpdateBlockDesign,
  contactsUpdateIsActive,
  contactsUpdateIsLoading,
  selectContactsBlockContent,
  selectContactsBlockDesign,
  selectContactsId,
  selectContactsUID,
} from '@store/slices/blocks/contacts/contactsSlice.js';
import {
  couponClear,
  couponStore,
  couponUpdateBlockContent,
  couponUpdateBlockDesign,
  couponUpdateIsActive,
  couponUpdateIsLoading,
  selectCouponBlockContent,
  selectCouponBlockDesign,
  selectCouponId,
  selectCouponUID,
} from '@store/slices/blocks/coupon/couponSlice.js';
import {
  courseClear,
  courseStore,
  courseUpdateBlockContent,
  courseUpdateBlockDesign,
  courseUpdateIsActive,
  courseUpdateIsLoading,
  selectCourseBlockContent,
  selectCourseBlockDesign,
  selectCourseId,
  selectCourseUID,
} from '@store/slices/blocks/course/courseSlice.js';
import {
  crowdfundingClear,
  crowdfundingStore,
  crowdfundingUpdateBlockContent,
  crowdfundingUpdateIsActive,
  crowdfundingUpdateIsLoading,
  selectCrowdfundingBlockContent,
  selectCrowdfundingId,
} from '@store/slices/blocks/crowdfunding/crowdfundingSlice.js';
import {
  dataCollectClear,
  dataCollectStore,
  dataCollectUpdateBlockContent,
  dataCollectUpdateBlockDesign,
  dataCollectUpdateIsActive,
  dataCollectUpdateIsLoading,
  selectDataCollectBlockContent,
  selectDataCollectBlockDesign,
  selectDataCollectId,
  selectDataCollectUID,
} from '@store/slices/blocks/dataCollect/dataCollectSlice.js';
import {
  digitalClear,
  digitalStore,
  digitalUpdateBlockContent,
  digitalUpdateBlockDesign,
  digitalUpdateIsActive,
  digitalUpdateIsLoading,
  selectDigitalBlockContent,
  selectDigitalBlockDesign,
  selectDigitalId,
  selectDigitalUID,
} from '@store/slices/blocks/digital/digitalSlice.js';
import {
  discountBlockClear,
  discountBlockStore,
  discountBlockUpdateBlockContent,
  discountBlockUpdateIsActive,
  discountBlockUpdateIsLoading,
  selectDiscountBlockContent,
  selectDiscountBlockId,
} from '@store/slices/blocks/discountBlock/discountBlockSlice.js';
import {
  donationClear,
  donationStore,
  donationUpdateBlockContent,
  donationUpdateBlockDesign,
  donationUpdateBlockSettings,
  donationUpdateIsActive,
  donationUpdateIsLoading,
  selectDonationBlockContent,
  selectDonationBlockDesign,
  selectDonationId,
  selectDonationUID,
} from '@store/slices/blocks/donation/donationSlice.js';
import {
  eventClear,
  eventStore,
  eventUpdateBlockContent,
  eventUpdateBlockDesign,
  eventUpdateIsActive,
  eventUpdateIsLoading,
  selectEventBlockContent,
  selectEventBlockDesign,
  selectEventButtonDesign,
  selectEventId,
  selectEventItemDesign,
  selectEventUID,
} from '@store/slices/blocks/event/eventSlice.js';
import {
  faqClear,
  faqStore,
  faqUpdateBlockContent,
  faqUpdateBlockDesign,
  faqUpdateBlockPreviewContent,
  faqUpdateBlockPreviewDesign,
  faqUpdateIsActive,
  faqUpdateIsLoading,
  selectFaqBlockContent,
  selectFaqBlockDesign,
  selectFaqId,
  selectFaqPreviewContent,
} from '@store/slices/blocks/faq/faqSlice.js';
import {
  featuresClear,
  featuresStore,
  featuresUpdateBlockContent,
  featuresUpdateBlockDesign,
  featuresUpdateIsActive,
  featuresUpdateIsLoading,
  selectFeaturesBlockContent,
  selectFeaturesBlockDesign,
  selectFeaturesId,
} from '@store/slices/blocks/features/featuresSlice.js';
import {
  clearFileBlock,
  fileStore,
  fileUpdateBlockPreviewContent,
  fileUpdateBlockPreviewDesign,
  fileUpdateDesign,
  fileUpdateIsActive,
  fileUpdateIsLoading,
  selectFileBlockContent,
  selectFileBlockDesign,
  selectFileId,
  selectFilePreviewContent,
  selectFileUID,
  updateFileBlockContent,
} from '@store/slices/blocks/file/fileSlice.js';
import {
  footerStore,
  footerUpdateBlockContent,
  footerUpdateIsActive,
  footerUpdateIsLoading,
  selectFooterBlockContent,
  selectFooterId,
} from '@store/slices/blocks/footer/footerSlice.js';
import {
  formClear,
  formStore,
  formUpdateBlockContent,
  formUpdateBlockDesign,
  formUpdateBlockPreviewContent,
  formUpdateBlockPreviewDesign,
  formUpdateIsActive,
  formUpdateIsLoading,
  selectFormBlockContent,
  selectFormBlockDesign,
  selectFormId,
  selectFormPreviewContent,
  selectFormUID,
} from '@store/slices/blocks/form/formSlice.js';
import {
  galleryClear,
  galleryStore,
  galleryUpdateBlockContent,
  galleryUpdateBlockDesign,
  galleryUpdateIsActive,
  galleryUpdateIsLoading,
  selectGalleryBlockContent,
  selectGalleryBlockDesign,
  selectGalleryId,
  selectGalleryUID,
} from '@store/slices/blocks/gallery/gallerySlice.js';
import {
  guestbookClear,
  guestbookStore,
  guestbookUpdateBlockContent,
  guestbookUpdateIsActive,
  guestbookUpdateIsLoading,
  selectGuestbookBlockContent,
  selectGuestbookId,
} from '@store/slices/blocks/guestbook/guestbookSlice.js';
import { headerClear, headerStore, headerUpdateIsActive, headerUpdateIsLoading } from '@store/slices/blocks/header/headerSlice.js';
import {
  highlightsClear,
  highlightsStore,
  highlightsUpdateBlockContent,
  highlightsUpdateIsActive,
  highlightsUpdateIsLoading,
  selectHighlightsBlockContent,
  selectHighlightsId,
} from '@store/slices/blocks/highlights/highlightsSlice.js';
import {
  htmlClear,
  htmlStore,
  htmlUpdateBlockContent,
  htmlUpdateIsActive,
  htmlUpdateIsLoading,
  selectHTMLBlockContent,
  selectHTMLId,
} from '@store/slices/blocks/html/htmlSlice.js';
import {
  instagramClear,
  instagramStore,
  instagramUpdateBlockContent,
  instagramUpdateBlockDesign,
  instagramUpdateIsActive,
  instagramUpdateIsLoading,
  selectInstagramBlockContent,
  selectInstagramBlockDesign,
  selectInstagramId,
  selectInstagramUID,
} from '@store/slices/blocks/instagram/instagramSlice.js';
import {
  linksClear,
  linksStore,
  linksUpdateBlockDesign,
  linksUpdateIsActive,
  linksUpdateIsLoading,
  selectLinksBlockContent,
  selectLinksBlockDesign,
  selectLinksId,
  selectLinksUID,
} from '@store/slices/blocks/links/linksSlice.js';
import {
  livestreamClear,
  livestreamStore,
  livestreamUpdateBlockContent,
  livestreamUpdateIsActive,
  livestreamUpdateIsLoading,
  selectLiveStreamBlockContent,
  selectLiveStreamId,
} from '@store/slices/blocks/livestream/livestreamSlice.js';
import {
  mapClear,
  mapStore,
  mapUpdateBlockContent,
  mapUpdateBlockDesign,
  mapUpdateIsActive,
  mapUpdateIsLoading,
  selectMapBlockContent,
  selectMapBlockDesign,
  selectMapId,
  selectMapUID,
} from '@store/slices/blocks/map/mapSlice.js';
import {
  mediaKitClear,
  mediaKitStore,
  mediaKitUpdateBlockContent,
  mediaKitUpdateBlockDesign,
  mediaKitUpdateIsActive,
  mediaKitUpdateIsLoading,
  selectMediaKitBlockContent,
  selectMediaKitBlockDesign,
  selectMediaKitId,
  selectMediaKitUID,
} from '@store/slices/blocks/mediaKit/mediaKitSlice.js';
import {
  musicClear,
  musicStore,
  musicUpdateBlockContent,
  musicUpdateIsActive,
  musicUpdateIsLoading,
  selectMusicBlockContent,
  selectMusicBlockDesign,
  selectMusicId,
  selectMusicUID,
} from '@store/slices/blocks/music/musicSlice.js';
import {
  nftClear,
  nftStore,
  nftUpdateBlockContent,
  nftUpdateBlockDesign,
  nftUpdateIsActive,
  nftUpdateIsLoading,
  selectNftBlockContent,
  selectNftId,
} from '@store/slices/blocks/nft/nftSlice.js';
import {
  outfitClear,
  outfitStore,
  outfitUpdateBlockContent,
  outfitUpdateBlockDesign,
  outfitUpdateIsActive,
  outfitUpdateIsLoading,
  selectOutfitBlockContent,
  selectOutfitBlockDesign,
  selectOutfitId,
  selectOutfitUID,
} from '@store/slices/blocks/outfit/outfitSlice.js';
import {
  pollClear,
  pollStore,
  pollUpdateBlockContent,
  pollUpdateBlockDesign,
  pollUpdateIsActive,
  pollUpdateIsLoading,
  selectPollBlockContent,
  selectPollBlockDesign,
  selectPollId,
  selectPollUID,
} from '@store/slices/blocks/poll/pollSlice.js';
import {
  premiumInboxClear,
  premiumInboxStore,
  premiumInboxUpdateBlockContent,
  premiumInboxUpdateIsActive,
  premiumInboxUpdateIsLoading,
  selectPremiumInboxBlockContent,
  selectPremiumInboxId,
} from '@store/slices/blocks/premiumInbox/premiumInboxSlice.js';
import {
  pricingClear,
  pricingStore,
  pricingUpdateBlockContent,
  pricingUpdateBlockDesign,
  pricingUpdateIsActive,
  pricingUpdateIsLoading,
  selectPricingBlockContent,
  selectPricingBlockDesign,
  selectPricingId,
  selectPricingUID,
} from '@store/slices/blocks/pricing/pricingSlice.js';
import {
  promoClear,
  promoStore,
  promoUpdateBlockContent,
  promoUpdateBlockDesign,
  promoUpdateBlockSettings,
  promoUpdateIsActive,
  promoUpdateIsLoading,
  selectPromoBlockContent,
  selectPromoId,
} from '@store/slices/blocks/promo/promoSlice.js';
import {
  recipeClear,
  recipeStore,
  recipeUpdateBlockContent,
  recipeUpdateIsActive,
  recipeUpdateIsLoading,
  selectRecipeBlockContent,
  selectRecipeId,
} from '@store/slices/blocks/recipe/recipeSlice.js';
import {
  reviewClear,
  reviewStore,
  reviewUpdateBlockContent,
  reviewUpdateBlockDesign,
  reviewUpdateIsActive,
  reviewUpdateIsLoading,
  selectReviewBlockContent,
  selectReviewId,
} from '@store/slices/blocks/review/reviewSlice.js';
import {
  selectServiceBlockContent,
  selectServiceBlockDesign,
  selectServiceButtonDesign,
  selectServiceId,
  selectServiceItemDesign,
  selectServiceUID,
  serviceClear,
  serviceStore,
  serviceUpdateBlockContent,
  serviceUpdateBlockDesign,
  serviceUpdateIsActive,
  serviceUpdateIsLoading,
} from '@store/slices/blocks/service/serviceSlice.js';
import {
  selectShopBlockContent,
  selectShopBlockDesign,
  selectShopId,
  selectShopUID,
  shopClear,
  shopStore,
  shopUpdateBlockContent,
  shopUpdateBlockDesign,
  shopUpdateBlockSettings,
  shopUpdateIsActive,
  shopUpdateIsLoading,
} from '@store/slices/blocks/shop/shopSlice.js';
import {
  selectShoutoutBlockContent,
  selectShoutoutId,
  shoutoutClear,
  shoutoutStore,
  shoutoutUpdateBlockContent,
  shoutoutUpdateIsActive,
  shoutoutUpdateIsLoading,
} from '@store/slices/blocks/shoutout/shoutoutSlice.js';
import {
  selectSliderBlockContent,
  selectSliderId,
  sliderClear,
  sliderStore,
  sliderUpdateBlockContent,
  sliderUpdateBlockDesign,
  sliderUpdateIsActive,
  sliderUpdateIsLoading,
} from '@store/slices/blocks/slider/sliderSlice.js';
import {
  selectSpacerBlockContent,
  selectSpacerId,
  spacerClear,
  spacerStore,
  spacerUpdateBlockContent,
  spacerUpdateIsActive,
  spacerUpdateIsLoading,
} from '@store/slices/blocks/spacer/spacerSlice.js';
import {
  selectSplashBlockContent,
  selectSplashId,
  splashClear,
  splashStore,
  splashUpdateBlockContent,
  splashUpdateIsActive,
  splashUpdateIsLoading,
} from '@store/slices/blocks/splash/splashSlice.js';
import {
  selectStatsBlockContent,
  selectStatsBlockDesign,
  selectStatsId,
  selectStatsPreviewContent,
  selectStatsUID,
  statsClearBlock,
  statsStore,
  statsUpdateBlockContent,
  statsUpdateBlockDesign,
  statsUpdateBlockPreviewContent,
  statsUpdateBlockPreviewDesign,
  statsUpdateIsActive,
  statsUpdateIsLoading,
} from '@store/slices/blocks/statistics/statisticsSlice.js';
import {
  selectStatusBlockContent,
  selectStatusId,
  statusClear,
  statusStore,
  statusUpdateBlockContent,
  statusUpdateIsActive,
  statusUpdateIsLoading,
} from '@store/slices/blocks/status/statusSlice.js';
import {
  selectTextBlockContent,
  selectTextContainerDesign,
  selectTextId,
  selectTextUID,
  textClear,
  textStore,
  textUpdateBlockContent,
  textUpdateIsActive,
  textUpdateIsLoading,
} from '@store/slices/blocks/text/textSlice.js';
import {
  selectTikTokBlockContent,
  selectTikTokBlockDesign,
  selectTikTokId,
  selectTikTokUID,
  tiktokClear,
  tiktokStore,
  tiktokUpdateBlockContent,
  tiktokUpdateBlockDesign,
  tiktokUpdateIsActive,
  tiktokUpdateIsLoading,
} from '@store/slices/blocks/tiktok/tiktokSlice.js';
import {
  selectTimelineBlockContent,
  selectTimelineBlockDesign,
  selectTimelineId,
  selectTimelineUID,
  timelineClear,
  timelineStore,
  timelineUpdateBlockContent,
  timelineUpdateBlockDesign,
  timelineUpdateIsActive,
  timelineUpdateIsLoading,
} from '@store/slices/blocks/timeline/timelineSlice.js';
import {
  selectTimerBlockContent,
  selectTimerId,
  timerClear,
  timerStore,
  timerUpdateBlockContent,
  timerUpdateBlockDesign,
  timerUpdateIsActive,
  timerUpdateIsLoading,
} from '@store/slices/blocks/timer/timerSlice.js';
import {
  selectTwitchBlockContent,
  selectTwitchId,
  twitchClear,
  twitchStore,
  twitchUpdateBlockContent,
  twitchUpdateIsActive,
  twitchUpdateIsLoading,
} from '@store/slices/blocks/twitch/twitchSlice.js';
import {
  selectTwitterBlockContent,
  selectTwitterId,
  twitterClear,
  twitterStore,
  twitterUpdateBlockContent,
  twitterUpdateIsActive,
  twitterUpdateIsLoading,
} from '@store/slices/blocks/twitter/twitterSlice.js';
import {
  selectVideoBlockContent,
  selectVideoBlockDesign,
  selectVideoId,
  selectVideoUID,
  videoClear,
  videoStore,
  videoUpdateBlockContent,
  videoUpdateBlockDesign,
  videoUpdateIsActive,
  videoUpdateIsLoading,
} from '@store/slices/blocks/video/videoSlice.js';
import {
  selectVideoFeedbackBlockContent,
  selectVideoFeedbackId,
  videoFeedbackClear,
  videoFeedbackStore,
  videoFeedbackUpdateBlockContent,
  videoFeedbackUpdateIsActive,
  videoFeedbackUpdateIsLoading,
} from '@store/slices/blocks/videoFeedback/videoFeedbackSlice.js';
import {
  selectWalletBlockContent,
  selectWalletBlockDesign,
  selectWalletId,
  selectWalletUID,
  walletClear,
  walletStore,
  walletUpdateBlockContent,
  walletUpdateBlockDesign,
  walletUpdateIsActive,
  walletUpdateIsLoading,
} from '@store/slices/blocks/wallet/walletSlice.js';
import {
  selectWelcomeBlockContent,
  selectWelcomeId,
  welcomeClear,
  welcomeStore,
  welcomeUpdateBlockContent,
  welcomeUpdateBlockDesign,
  welcomeUpdateIsActive,
  welcomeUpdateIsLoading,
} from '@store/slices/blocks/welcome/welcomeSlice.js';
import {
  selectWorkoutBlockContent,
  selectWorkoutId,
  workoutClear,
  workoutStore,
  workoutUpdateBlockContent,
  workoutUpdateIsActive,
  workoutUpdateIsLoading,
} from '@store/slices/blocks/workout/workoutSlice.js';
import {
  selectYouTubeBlockContent,
  selectYouTubeBlockDesign,
  selectYouTubeId,
  selectYouTubeUID,
  youtubeClear,
  youtubeStore,
  youtubeUpdateBlockContent,
  youtubeUpdateBlockDesign,
  youtubeUpdateIsActive,
  youtubeUpdateIsLoading,
} from '@store/slices/blocks/youtube/youtubeSlice.js';
import { commonUpdateIsLoadingStore, commonUpdateIsOpenStandAloneModal, commonUpdateStandAloneData, commonUpdateStandAloneLinkItemData } from '@store/slices/common/commonSlice.js';
import { bookingActions } from '@store/toolkit/blocks/booking/index.js';
import { selectMembershipUID } from '@store/toolkit/blocks/membership/membershipSelectors.js';
import { menuActions } from '@store/toolkit/blocks/menu/index.js';
import { podcastActions } from '@store/toolkit/blocks/podcast/index.js';
import { podcastUpdateBlockContent, podcastUpdateIsActive, podcastUpdateIsLoading } from '@store/toolkit/blocks/podcast/podcastActions.js';
import { selectPodcastBlockContent, selectPodcastBlockDesign, selectPodcastId, selectPodcastUID } from '@store/toolkit/blocks/podcast/podcastSelectors.js';
import * as toastrActions from '@store/toolkit/toastr/toastrActions.js';
import { BLOCK_TYPES } from '@utils/constants.js';
import httpClient from '@utils/httpClient.js';
import { sectionTypes } from '@utils/sectionEnums.js';

import {
  aiAppClear,
  aiAppStore,
  aiAppUpdateBlockContent,
  aiAppUpdateBlockDesign,
  aiAppUpdateIsActive,
  aiAppUpdateIsLoading,
  selectAiAppBlockContent,
  selectAiAppBlockDesign,
  selectAiAppId,
  selectAiAppUID,
} from '@/store/slices/blocks/aiApp/aiAppSlice.ts';
import {
  chatClear,
  chatStore,
  chatUpdateBlockContent,
  chatUpdateBlockDesign,
  chatUpdateIsActive,
  chatUpdateIsLoading,
  selectChatBlockContent,
  selectChatBlockDesign,
  selectChatId,
  selectChatUID,
} from '@/store/slices/blocks/chatAi/chatAiSlice.js';
import {
  listingClear,
  listingStore,
  listingUpdateBlockContent,
  listingUpdateBlockDesign,
  listingUpdateIsActive,
  listingUpdateIsLoading,
  selectListingBlockContent,
  selectListingBlockDesign,
  selectListingId,
  selectListingUID,
} from '@/store/slices/blocks/listing/listingSlice.js';
import {
  overviewClear,
  overviewStore,
  overviewUpdateBlockContent,
  overviewUpdateBlockDesign,
  overviewUpdateIsActive,
  overviewUpdateIsLoading,
  selectOverviewBlockContent,
  selectOverviewBlockDesign,
  selectOverviewId,
  selectOverviewUID,
} from '@/store/slices/blocks/overview/overviewSlice.js';
import {
  pageListClear,
  pageListIsActive,
  pageListIsLoading,
  pageListStore,
  pageListUpdateBlockDesing,
  selectPageListBlockContent,
  selectPageListId,
  selectPageListUID,
  updatePageListBlockContent,
} from '@/store/slices/blocks/page-list/pageListSlice.js';
import {
  rentalClear,
  rentalStore,
  rentalUpdateBlockContent,
  rentalUpdateBlockDesign,
  rentalUpdateIsActive,
  rentalUpdateIsLoading,
  selectRentalBlockContent,
  selectRentalBlockDesign,
  selectRentalId,
  selectRentalUID,
} from '@/store/slices/blocks/rental/rentalSlice.js';
import {
  selectSingleProductBlockContent,
  selectSingleProductBlockDesign,
  selectSingleProductId,
  selectSingleProductUID,
  singleProductClear,
  singleProductStore,
  singleProductUpdateBlockContent,
  singleProductUpdateBlockDesign,
  singleProductUpdateIsActive,
  singleProductUpdateIsLoading,
} from '@/store/slices/blocks/singleProduct/singleProductSlice.js';
import {
  selectTeamBlockContent,
  selectTeamBlockDesign,
  selectTeamId,
  selectTeamUID,
  teamClear,
  teamStore,
  teamUpdateBlockContent,
  teamUpdateBlockDesign,
  teamUpdateIsActive,
  teamUpdateIsLoading,
} from '@/store/slices/blocks/team/teamSlice.js';
import {
  selectTimetableBlockContent,
  selectTimetableBlockDesign,
  selectTimetableId,
  selectTimetableUID,
  timetableClear,
  timetableStore,
  timetableUpdateBlockContent,
  timetableUpdateBlockDesign,
  timetableUpdateIsActive,
  timetableUpdateIsLoading,
} from '@/store/slices/blocks/timetable/timetableSlice.js';
import {
  selectTrustBlockContent,
  selectTrustBlockDesign,
  selectTrustId,
  selectTrustUID,
  trustClear,
  trustStore,
  trustUpdateBlockContent,
  trustUpdateBlockDesign,
  trustUpdateIsActive,
  trustUpdateIsLoading,
} from '@/store/slices/blocks/trust/trustSlice.js';
import {
  selectUnlockBlockContent,
  selectUnlockBlockDesign,
  selectUnlockId,
  selectUnlockUID,
  unlockClear,
  unlockStore,
  unlockUpdateBlockContent,
  unlockUpdateBlockDesign,
  unlockUpdateIsActive,
  unlockUpdateIsLoading,
} from '@/store/slices/blocks/unlock/unlockSlice.js';
import { bookingUpdateBlockContent, bookingUpdateIsActive, bookingUpdateIsLoading } from '@/store/toolkit/blocks/booking/bookingActions.js';
import { selectBookingBlockContent, selectBookingBlockDesign, selectBookingId, selectBookingUID } from '@/store/toolkit/blocks/booking/bookingSelectors.js';
import { menuUpdateBlockContent, menuUpdateIsActive, menuUpdateIsLoading } from '@/store/toolkit/blocks/menu/menuActions.js';
import { selectMenuBlockContent, selectMenuBlockDesign, selectMenuId, selectMenuUID } from '@/store/toolkit/blocks/menu/menuSelectors.js';

import {
  membershipClear,
  membershipStore,
  membershipUpdateBlockContent,
  membershipUpdateBlockDesign,
  membershipUpdateIsActive,
  membershipUpdateIsLoading,
  selectMembershipBlockContent,
  selectMembershipBlockDesign,
  selectMembershipId,
} from '../../../../../../../../../store/slices/blocks/membership/membershipSlice.js';

export function fetchStandalone(profileId, fields, dispatch, onSetIsLoading = () => {}, linkItemData = null) {
  onSetIsLoading(fields?.itemId);
  httpClient
    // .post(`api/profiles/${profileId}/standalone-pages`, {
    .post(`api/profiles/${profileId}/short-links/share`, {
      ...fields,
      targetType: 'redirect',
    })
    .then((res) => {
      dispatch(commonUpdateStandAloneData(res.data));
      if (linkItemData) {
        dispatch(commonUpdateStandAloneLinkItemData(linkItemData));
      }
      dispatch(commonUpdateIsOpenStandAloneModal(true));
    })
    .catch((error) => {
      console.log(error);
      dispatch(toastrActions.toastrShowError('Error standalone!'));
    })
    .finally(() => {
      onSetIsLoading(null);
      // dispatch(toastrActions.toastrShowSuccess('Appearance saved!'));
    });
}

export function fetchBlocks(blocks, activePageId, profileId, dispatch, translation = 'Appearance saved!') {
  const message = typeof translation === 'string' ? translation : 'Appearance saved!';
  httpClient
    .put(`api/profiles/${profileId}/blocks`, {
      pageId: activePageId,
      blocks,
      timestamp: new Date().toISOString(),
    })
    .then((res) => {
      console.log(res);
    })
    .finally(() => {
      setTimeout(() => {
        dispatch(toastrActions.toastrShowSuccess(message));
      }, 0);
    });
}

export const getBlockType = (blockOrType) => (typeof blockOrType === 'string' ? blockOrType : blockOrType?.type);

export const getPromoPlacement = (blockOrType) => {
  if (!blockOrType || typeof blockOrType === 'string') {
    return 'top';
  }

  const placement = blockOrType?.data?.blockDesign?.view ?? blockOrType?.blockDesign?.view ?? blockOrType?.view;

  return placement === 'middle' ? 'middle' : 'top';
};

export const getStaticBlockOrder = (blockOrType) => {
  const type = getBlockType(blockOrType);

  if (type === sectionTypes.promo.type && getPromoPlacement(blockOrType) === 'middle') {
    return null;
  }

  switch (type) {
    case sectionTypes.splash.type:
      return 0;
    case sectionTypes.promo.type:
      return 1;
    case sectionTypes.header.type:
      return 2;
    case sectionTypes.welcome.type:
      return 3;
    case sectionTypes.footer.type:
      return 4;
    default:
      return null;
  }
};

export const checkIsDragBlock = (blockOrType) => {
  const type = getBlockType(blockOrType);

  if (type === sectionTypes.promo.type) {
    return getPromoPlacement(blockOrType) === 'middle';
  }

  return type !== sectionTypes.splash.type && type !== sectionTypes.header.type && type !== sectionTypes.footer.type && type !== sectionTypes.welcome.type;

  /*  return getStaticBlockOrder(type) === null; */
};

export const arrangeBlocksWithSequentialN = (blocks) => {
  const staticBlocks = blocks.filter((el) => !checkIsDragBlock(el));
  const dragBlocks = blocks.filter((el) => checkIsDragBlock(el));
  const sortedStaticBlocks = staticBlocks

    .map((block) => ({
      block,
      order: getStaticBlockOrder(block),
    }))
    .filter((item) => item.order !== null)
    .sort((a, b) => a.order - b.order)
    .map((item) => item.block);

  const staticBlocksBeforeDrag = sortedStaticBlocks.filter((block) => getStaticBlockOrder(block) < 3.5);
  const staticBlocksAfterDrag = sortedStaticBlocks.filter((block) => getStaticBlockOrder(block) >= 3.5);
  const arrangedBlocks = [...staticBlocksBeforeDrag, ...dragBlocks, ...staticBlocksAfterDrag];
  return arrangedBlocks.map((block, index) => ({
    ...block,
    n: index,
  }));
};

export const updateBlocks = (activeType, data, blocksList, dragList, setDragList) => {
  const { id, uid } = data;
  let updatedSectionList;
  const isDragSection = checkIsDragBlock(data ?? activeType);

  if (isDragSection) {
    // const currentNumber = dragList.length + 1;
    // setDragList([...dragList, { type: activeType, id, n: currentNumber, uid, isAdded: true, isActive: true }]);
    //
    // updatedSectionList = [
    //   ...blocksList,
    //   {
    //     uid,
    //     type: activeType,
    //     n: currentNumber,
    //     isActive: true,
    //     isAdded: true,
    //   },
    // ];

    // const currentNumber = dragList.length + 1;

    const updatedDragList = dragList.map((el) => {
      return {
        ...el,
        n: el?.n + 1,
      };
    });

    setDragList([{ type: activeType, id, n: 1, uid, isAdded: true, isActive: true }, ...updatedDragList]);

    const updatedBlocksList = blocksList.map((el) => {
      return {
        ...el,
        n: el?.n + 1,
      };
    });

    updatedSectionList = [
      {
        uid,
        type: activeType,
        n: 1,
        isActive: true,
        isAdded: true,
      },
      ...updatedBlocksList,
    ];
  } else {
    updatedSectionList = [
      ...blocksList,
      {
        type: activeType,
        n: 0,
        isActive: true,
        isAdded: true,
      },
    ];
  }

  return updatedSectionList;
};

export const convertBlocksDataToSave = (blocks) =>
  blocks.map((el) => {
    const { id, sid, uid, pageId, profileId, isActive, type, title, n } = el;
    return {
      id,
      sid,
      uid,
      pageId,
      profileId,
      isActive,
      type,
      title,
      n,
    };
  });

export const onChangeIsBlockDragList = (uid, value, dragList, setDragList) => {
  const updatedDragList = dragList.map((el) => {
    if (el.uid === uid) {
      return {
        ...el,
        isActive: value,
      };
    }

    return el;
  });

  setDragList(updatedDragList);
};

export const parseBlock = (type, data, dispatch) => {
  switch (type) {
    case BLOCK_TYPES.header:
      dispatch(headerStore(data));
      break;
    case BLOCK_TYPES.text:
      dispatch(textStore(data));
      break;
    case BLOCK_TYPES.links:
      dispatch(linksStore(data));
      break;
    case BLOCK_TYPES.dataCollect:
      dispatch(dataCollectStore(data));
      break;
    case BLOCK_TYPES.poll:
      dispatch(pollStore(data));
      break;
    case BLOCK_TYPES.apps:
      dispatch(appsStore(data));
      break;
    case BLOCK_TYPES.community:
      dispatch(communityStore(data));
      break;
    case BLOCK_TYPES.mediaKit:
      dispatch(mediaKitStore(data));
      break;
    case BLOCK_TYPES.form:
      dispatch(formStore(data));
      break;
    case BLOCK_TYPES.contacts:
      dispatch(contactsStore(data));
      break;
    case BLOCK_TYPES.faq:
      dispatch(faqStore(data));
      break;
    case BLOCK_TYPES.recipe:
      dispatch(recipeStore(data));
      break;
    case BLOCK_TYPES.ama:
      dispatch(amaStore(data));
      break;
    case BLOCK_TYPES.wall:
      dispatch(guestbookStore(data));
      break;
    case BLOCK_TYPES.videoFeedback:
      dispatch(videoFeedbackStore(data));
      break;
    case BLOCK_TYPES.shoutout:
      dispatch(shoutoutStore(data));
      break;
    case BLOCK_TYPES.audioInbox:
      dispatch(audioInboxStore(data));
      break;
    case BLOCK_TYPES.status:
      dispatch(statusStore(data));
      break;
    case BLOCK_TYPES.crowdfunding:
      dispatch(crowdfundingStore(data));
      break;
    case BLOCK_TYPES.premiumInbox:
      dispatch(premiumInboxStore(data));
      break;
    case BLOCK_TYPES.livestream:
      dispatch(livestreamStore(data));
      break;
    case BLOCK_TYPES.workout:
      dispatch(workoutStore(data));
      break;
    case BLOCK_TYPES.features:
      dispatch(featuresStore(data));
      break;
    case BLOCK_TYPES.highlights:
      dispatch(highlightsStore(data));
      break;
    case BLOCK_TYPES.banner:
      dispatch(bannerStore(data));
      break;
    case BLOCK_TYPES.slider:
      dispatch(sliderStore(data));
      break;
    case BLOCK_TYPES.gallery:
      dispatch(galleryStore(data));
      break;
    case BLOCK_TYPES.blog:
      dispatch(blogStore(data));
      break;
    case BLOCK_TYPES.map:
      dispatch(mapStore(data));
      break;
    case BLOCK_TYPES.footer:
      dispatch(footerStore(data));
      break;
    case BLOCK_TYPES.chatAi:
      dispatch(chatStore(data));
      break;
    case BLOCK_TYPES.custom:
      dispatch(aiAppStore(data));
      break;

    // ------------ Make and collect money ------------
    case BLOCK_TYPES.shop:
      dispatch(shopStore(data));
      break;
    case BLOCK_TYPES.digital:
      dispatch(digitalStore(data));
      break;
    case BLOCK_TYPES.appointment:
      dispatch(appointmentStore(data));
      break;
    case BLOCK_TYPES.service:
      dispatch(serviceStore(data));
      break;
    case BLOCK_TYPES.trust:
      dispatch(trustStore(data));
      break;
    case BLOCK_TYPES.listing:
      dispatch(listingStore(data));
      break;
    case BLOCK_TYPES.overview:
      dispatch(overviewStore(data));
      break;
    case BLOCK_TYPES.rental:
      dispatch(rentalStore(data));
      break;
    case BLOCK_TYPES.singleProduct:
      dispatch(singleProductStore(data));
      break;
    case BLOCK_TYPES.team:
      dispatch(teamStore(data));
      break;
    case BLOCK_TYPES.timetable:
      dispatch(timetableStore(data));
      break;
    case BLOCK_TYPES.unlock:
      dispatch(unlockStore(data));
      break;
    case BLOCK_TYPES.donation:
    case BLOCK_TYPES.tips:
      dispatch(donationStore(data));
      break;
    case BLOCK_TYPES.course:
      dispatch(courseStore(data));
      break;
    case BLOCK_TYPES.event:
      dispatch(eventStore(data));
      break;
    case BLOCK_TYPES.timeline:
      dispatch(timelineStore(data));
      break;
    case BLOCK_TYPES.membership:
      dispatch(membershipStore(data));
      break;
    case BLOCK_TYPES.pricing:
      dispatch(pricingStore(data));
      break;
    case BLOCK_TYPES.nft:
      dispatch(nftStore(data));
      break;
    case BLOCK_TYPES.wallet:
      dispatch(walletStore(data));
      break;
    case BLOCK_TYPES.menu:
      dispatch(menuActions.menuStore(data));
      break;
    case BLOCK_TYPES.booking:
      dispatch(bookingActions.bookingStore(data));
      break;

    // ------------ Social media content ------------
    case BLOCK_TYPES.instagram:
      dispatch(instagramStore(data));
      break;
    case BLOCK_TYPES.tiktok:
      dispatch(tiktokStore(data));
      break;
    case BLOCK_TYPES.youtube:
      dispatch(youtubeStore(data));
      break;
    case BLOCK_TYPES.twitter:
      dispatch(twitterStore(data));
      break;
    case BLOCK_TYPES.music:
      dispatch(musicStore(data));
      break;
    case BLOCK_TYPES.podcast:
      dispatch(podcastActions.podcastStore(data));
      break;
    case BLOCK_TYPES.twitch:
      dispatch(twitchStore(data));
      break;

    // ------------ Growth tools ------------
    case BLOCK_TYPES.splash:
      dispatch(splashStore(data));
      break;
    case BLOCK_TYPES.promo:
      dispatch(promoStore(data));
      break;
    case BLOCK_TYPES.welcome:
      dispatch(welcomeStore(data));
      break;
    case BLOCK_TYPES.review:
      dispatch(reviewStore(data));
      break;
    case BLOCK_TYPES.coupon:
      dispatch(couponStore(data));
      break;
    case BLOCK_TYPES.discount:
      dispatch(discountBlockStore(data));
      break;
    case BLOCK_TYPES.timer:
      dispatch(timerStore(data));
      break;
    case BLOCK_TYPES.outfit:
      dispatch(outfitStore(data));
      break;
    case BLOCK_TYPES.spacer:
      dispatch(spacerStore(data));
      break;
    case BLOCK_TYPES.html:
      dispatch(htmlStore(data));
      break;

    case BLOCK_TYPES.video:
      dispatch(videoStore(data));
      break;
    case BLOCK_TYPES.file:
      dispatch(fileStore(data));
      break;
    case BLOCK_TYPES.stat:
      dispatch(statsStore(data));
      break;
    case BLOCK_TYPES.pageList:
      dispatch(pageListStore(data));
      break;
  }
};

export const clearBlock = (type, dispatch) => {
  switch (type) {
    case BLOCK_TYPES.header:
      dispatch(headerClear());
      break;
    case BLOCK_TYPES.text:
      dispatch(textClear());
      break;
    case BLOCK_TYPES.links:
      dispatch(linksClear());
      break;
    case BLOCK_TYPES.dataCollect:
      dispatch(dataCollectClear());
      break;
    case BLOCK_TYPES.poll:
      dispatch(pollClear());
      break;
    case BLOCK_TYPES.apps:
      dispatch(appsClear());
      break;
    case BLOCK_TYPES.community:
      dispatch(communityClear());
      break;
    case BLOCK_TYPES.mediaKit:
      dispatch(mediaKitClear());
      break;
    case BLOCK_TYPES.form:
      dispatch(formClear());
      break;
    case BLOCK_TYPES.contacts:
      dispatch(contactsClear());
      break;
    case BLOCK_TYPES.faq:
      dispatch(faqClear());
      break;
    case BLOCK_TYPES.recipe:
      dispatch(recipeClear());
      break;
    case BLOCK_TYPES.ama:
      dispatch(amaClear());
      break;
    case BLOCK_TYPES.wall:
      dispatch(guestbookClear());
      break;
    case BLOCK_TYPES.videoFeedback:
      dispatch(videoFeedbackClear());
      break;
    case BLOCK_TYPES.shoutout:
      dispatch(shoutoutClear());
      break;
    case BLOCK_TYPES.audioInbox:
      dispatch(audioInboxClear());
      break;
    case BLOCK_TYPES.status:
      dispatch(statusClear());
      break;
    case BLOCK_TYPES.crowdfunding:
      dispatch(crowdfundingClear());
      break;
    case BLOCK_TYPES.premiumInbox:
      dispatch(premiumInboxClear());
      break;
    case BLOCK_TYPES.livestream:
      dispatch(livestreamClear());
      break;
    case BLOCK_TYPES.workout:
      dispatch(workoutClear());
      break;
    case BLOCK_TYPES.features:
      dispatch(featuresClear());
      break;
    case BLOCK_TYPES.highlights:
      dispatch(highlightsClear());
      break;
    case BLOCK_TYPES.banner:
      dispatch(bannerClear());
      break;
    case BLOCK_TYPES.slider:
      dispatch(sliderClear());
      break;
    case BLOCK_TYPES.gallery:
      dispatch(galleryClear());
      break;
    case BLOCK_TYPES.blog:
      dispatch(blogClear());
      break;
    case BLOCK_TYPES.map:
      dispatch(mapClear());
      break;
    case BLOCK_TYPES.chatAi:
      dispatch(chatClear());
      break;
    case BLOCK_TYPES.custom:
      dispatch(aiAppClear());
      break;
    // case BLOCK_TYPES.footer:
    //   dispatch(footerClear());
    //   break;

    // ------------ Make and collect money ------------
    case BLOCK_TYPES.shop:
      dispatch(shopClear());
      break;
    case BLOCK_TYPES.digital:
      dispatch(digitalClear());
      break;
    case BLOCK_TYPES.appointment:
      dispatch(appointmentClear());
      break;
    case BLOCK_TYPES.service:
      dispatch(serviceClear());
      break;
    case BLOCK_TYPES.trust:
      dispatch(trustClear());
      break;
    case BLOCK_TYPES.listing:
      dispatch(listingClear());
      break;
    case BLOCK_TYPES.overview:
      dispatch(overviewClear());
      break;
    case BLOCK_TYPES.rental:
      dispatch(rentalClear());
      break;
    case BLOCK_TYPES.singleProduct:
      dispatch(singleProductClear());
      break;
    case BLOCK_TYPES.team:
      dispatch(teamClear());
      break;
    case BLOCK_TYPES.timetable:
      dispatch(timetableClear());
      break;
    case BLOCK_TYPES.unlock:
      dispatch(unlockClear());
      break;
    case BLOCK_TYPES.donation:
    case BLOCK_TYPES.tips:
      dispatch(donationClear());
      break;
    case BLOCK_TYPES.course:
      dispatch(courseClear());
      break;
    case BLOCK_TYPES.event:
      dispatch(eventClear());
      break;
    case BLOCK_TYPES.timeline:
      dispatch(timelineClear());
      break;
    case BLOCK_TYPES.membership:
      dispatch(membershipClear());
      break;
    case BLOCK_TYPES.pricing:
      dispatch(pricingClear());
      break;
    case BLOCK_TYPES.nft:
      dispatch(nftClear());
      break;
    case BLOCK_TYPES.wallet:
      dispatch(walletClear());
      break;
    case BLOCK_TYPES.menu:
      dispatch(menuActions.menuClear());
      break;
    case BLOCK_TYPES.booking:
      dispatch(bookingActions.bookingClear());
      break;
    // ------------ Social media content ------------
    case BLOCK_TYPES.instagram:
      dispatch(instagramClear());
      break;
    case BLOCK_TYPES.tiktok:
      dispatch(tiktokClear());
      break;
    case BLOCK_TYPES.youtube:
      dispatch(youtubeClear());
      break;
    case BLOCK_TYPES.twitter:
      dispatch(twitterClear());
      break;
    case BLOCK_TYPES.music:
      dispatch(musicClear());
      break;
    case BLOCK_TYPES.podcast:
      dispatch(podcastActions.podcastClear());
      break;
    case BLOCK_TYPES.twitch:
      dispatch(twitchClear());
      break;

    // ------------ Growth tools ------------
    case BLOCK_TYPES.splash:
      dispatch(splashClear());
      break;
    case BLOCK_TYPES.promo:
      dispatch(promoClear());
      break;
    case BLOCK_TYPES.welcome:
      dispatch(welcomeClear());
      break;
    case BLOCK_TYPES.review:
      dispatch(reviewClear());
      break;
    case BLOCK_TYPES.coupon:
      dispatch(couponClear());
      break;
    case BLOCK_TYPES.discount:
      dispatch(discountBlockClear());
      break;
    case BLOCK_TYPES.timer:
      dispatch(timerClear());
      break;
    case BLOCK_TYPES.outfit:
      dispatch(outfitClear());
      break;
    case BLOCK_TYPES.spacer:
      dispatch(spacerClear());
      break;
    case BLOCK_TYPES.html:
      dispatch(htmlClear());
      break;

    case BLOCK_TYPES.video:
      dispatch(videoClear());
      break;
    case BLOCK_TYPES.file:
      dispatch(clearFileBlock());
      break;
    case BLOCK_TYPES.stat:
      dispatch(statsClearBlock());
      break;
    case BLOCK_TYPES.pageList:
      dispatch(pageListClear());
      break;
  }
};

export const getActionUpdateBlockContent = (type) => {
  switch (type) {
    case BLOCK_TYPES.dataCollect:
      return dataCollectUpdateBlockContent;
    case BLOCK_TYPES.poll:
      return pollUpdateBlockContent;
    case BLOCK_TYPES.apps:
      return appsUpdateBlockContent;
    case BLOCK_TYPES.community:
      return communityUpdateBlockContent;
    case BLOCK_TYPES.mediaKit:
      return mediaKitUpdateBlockContent;
    case BLOCK_TYPES.form:
      return formUpdateBlockContent;
    case BLOCK_TYPES.faq:
      return faqUpdateBlockContent;
    case BLOCK_TYPES.recipe:
      return recipeUpdateBlockContent;
    case BLOCK_TYPES.ama:
      return amaUpdateBlockContent;
    case BLOCK_TYPES.wall:
      return guestbookUpdateBlockContent;
    case BLOCK_TYPES.videoFeedback:
      return videoFeedbackUpdateBlockContent;
    case BLOCK_TYPES.shoutout:
      return shoutoutUpdateBlockContent;
    case BLOCK_TYPES.audioInbox:
      return audioInboxUpdateBlockContent;
    case BLOCK_TYPES.status:
      return statusUpdateBlockContent;
    case BLOCK_TYPES.crowdfunding:
      return crowdfundingUpdateBlockContent;
    case BLOCK_TYPES.premiumInbox:
      return premiumInboxUpdateBlockContent;
    case BLOCK_TYPES.livestream:
      return livestreamUpdateBlockContent;
    case BLOCK_TYPES.workout:
      return workoutUpdateBlockContent;
    case BLOCK_TYPES.text:
      return textUpdateBlockContent;
    case BLOCK_TYPES.features:
      return featuresUpdateBlockContent;
    case BLOCK_TYPES.highlights:
      return highlightsUpdateBlockContent;
    case BLOCK_TYPES.banner:
      return bannerUpdateBlockContent;
    case BLOCK_TYPES.slider:
      return sliderUpdateBlockContent;
    case BLOCK_TYPES.gallery:
      return galleryUpdateBlockContent;
    case BLOCK_TYPES.blog:
      return blogUpdateBlockContent;
    case BLOCK_TYPES.map:
      return mapUpdateBlockContent;
    case BLOCK_TYPES.footer:
      return footerUpdateBlockContent;
    case BLOCK_TYPES.chatAi:
      return chatUpdateBlockContent;
    case BLOCK_TYPES.custom:
      return aiAppUpdateBlockContent;

    // ------------ Make and collect money ------------

    case BLOCK_TYPES.shop:
    case 'external':
      return shopUpdateBlockContent;
    case BLOCK_TYPES.digital:
      return digitalUpdateBlockContent;
    case BLOCK_TYPES.appointment:
      return appointmentUpdateBlockContent;
    case BLOCK_TYPES.service:
      return serviceUpdateBlockContent;

    case BLOCK_TYPES.trust:
      return trustUpdateBlockContent;
    case BLOCK_TYPES.listing:
      return listingUpdateBlockContent;
    case BLOCK_TYPES.overview:
      return overviewUpdateBlockContent;
    case BLOCK_TYPES.rental:
      return rentalUpdateBlockContent;
    case BLOCK_TYPES.singleProduct:
      return singleProductUpdateBlockContent;
    case BLOCK_TYPES.team:
      return teamUpdateBlockContent;
    case BLOCK_TYPES.timetable:
      return timetableUpdateBlockContent;
    case BLOCK_TYPES.unlock:
      return unlockUpdateBlockContent;
    case BLOCK_TYPES.donation:
    case BLOCK_TYPES.tips:
      return donationUpdateBlockContent;
    case BLOCK_TYPES.course:
      return courseUpdateBlockContent;
    case BLOCK_TYPES.event:
      return eventUpdateBlockContent;
    case BLOCK_TYPES.timeline:
      return timelineUpdateBlockContent;
    case BLOCK_TYPES.membership:
      return membershipUpdateBlockContent;
    case BLOCK_TYPES.pricing:
      return pricingUpdateBlockContent;
    case BLOCK_TYPES.booking:
      return bookingUpdateBlockContent;
    case BLOCK_TYPES.nft:
      return nftUpdateBlockContent;
    case BLOCK_TYPES.wallet:
      return walletUpdateBlockContent;
    case BLOCK_TYPES.menu:
      return menuUpdateBlockContent;

    // ------------ Social media content ------------
    case BLOCK_TYPES.youtube:
      return youtubeUpdateBlockContent;
    case BLOCK_TYPES.instagram:
      return instagramUpdateBlockContent;
    case BLOCK_TYPES.tiktok:
      return tiktokUpdateBlockContent;
    case BLOCK_TYPES.twitter:
      return twitterUpdateBlockContent;
    case BLOCK_TYPES.music:
      return musicUpdateBlockContent;
    case BLOCK_TYPES.podcast:
      return podcastUpdateBlockContent;
    case BLOCK_TYPES.twitch:
      return twitchUpdateBlockContent;

    // ------------ Growth tools ------------
    case BLOCK_TYPES.splash:
      return splashUpdateBlockContent;
    case BLOCK_TYPES.promo:
      return promoUpdateBlockContent;
    case BLOCK_TYPES.welcome:
      return welcomeUpdateBlockContent;
    case BLOCK_TYPES.review:
      return reviewUpdateBlockContent;
    case BLOCK_TYPES.coupon:
      return couponUpdateBlockContent;
    case BLOCK_TYPES.discount:
      return discountBlockUpdateBlockContent;
    case BLOCK_TYPES.timer:
      return timerUpdateBlockContent;
    case BLOCK_TYPES.outfit:
      return outfitUpdateBlockContent;
    case BLOCK_TYPES.spacer:
      return spacerUpdateBlockContent;
    case BLOCK_TYPES.html:
      return htmlUpdateBlockContent;
    case BLOCK_TYPES.pageList:
      return updatePageListBlockContent;

    case BLOCK_TYPES.video:
      return videoUpdateBlockContent;
    case BLOCK_TYPES.file:
      return updateFileBlockContent;
    case BLOCK_TYPES.stat:
      return statsUpdateBlockContent;

    default:
      return null;
  }
};

export const getActionUpdateBlockDesign = (type) => {
  switch (type) {
    case BLOCK_TYPES.links:
      return linksUpdateBlockDesign;
    case BLOCK_TYPES.dataCollect:
      return dataCollectUpdateBlockDesign;
    case BLOCK_TYPES.poll:
      return pollUpdateBlockDesign;
    case BLOCK_TYPES.apps:
      return appsUpdateBlockDesign;
    case BLOCK_TYPES.community:
      return communityUpdateBlockDesign;
    case BLOCK_TYPES.mediaKit:
      return mediaKitUpdateBlockDesign;
    case BLOCK_TYPES.form:
      return formUpdateBlockDesign;
    case BLOCK_TYPES.features:
      return featuresUpdateBlockDesign;
    case BLOCK_TYPES.banner:
      return bannerUpdateBlockDesign;
    case BLOCK_TYPES.slider:
      return sliderUpdateBlockDesign;
    case BLOCK_TYPES.gallery:
      return galleryUpdateBlockDesign;
    case BLOCK_TYPES.faq:
      return faqUpdateBlockDesign;
    case BLOCK_TYPES.blog:
      return blogUpdateBlockDesign;
    case BLOCK_TYPES.map:
      return mapUpdateBlockDesign;
    case BLOCK_TYPES.contacts:
      return contactsUpdateBlockDesign;
    case BLOCK_TYPES.chatAi:
      return chatUpdateBlockDesign;
    case BLOCK_TYPES.custom:
      return aiAppUpdateBlockDesign;

    // ------------ Make and collect money ------------
    case BLOCK_TYPES.digital:
      return digitalUpdateBlockDesign;
    case BLOCK_TYPES.appointment:
      return appointmentUpdateBlockDesign;
    case BLOCK_TYPES.shop:
      return shopUpdateBlockDesign;
    case BLOCK_TYPES.service:
      return serviceUpdateBlockDesign;
    case BLOCK_TYPES.trust:
      return trustUpdateBlockDesign;
    case BLOCK_TYPES.listing:
      return listingUpdateBlockDesign;
    case BLOCK_TYPES.overview:
      return overviewUpdateBlockDesign;
    case BLOCK_TYPES.rental:
      return rentalUpdateBlockDesign;
    case BLOCK_TYPES.singleProduct:
      return singleProductUpdateBlockDesign;
    case BLOCK_TYPES.team:
      return teamUpdateBlockDesign;
    case BLOCK_TYPES.timetable:
      return timetableUpdateBlockDesign;
    case BLOCK_TYPES.unlock:
      return unlockUpdateBlockDesign;
    case BLOCK_TYPES.donation:
    case BLOCK_TYPES.tips:
      return donationUpdateBlockDesign;
    case BLOCK_TYPES.course:
      return courseUpdateBlockDesign;
    case BLOCK_TYPES.event:
      return eventUpdateBlockDesign;
    case BLOCK_TYPES.timeline:
      return timelineUpdateBlockDesign;
    case BLOCK_TYPES.membership:
      return membershipUpdateBlockDesign;
    case BLOCK_TYPES.wallet:
      return walletUpdateBlockDesign;
    case BLOCK_TYPES.booking:
      return bookingActions.bookingUpdateBlockDesign;
    case BLOCK_TYPES.nft:
      return nftUpdateBlockDesign;
    case BLOCK_TYPES.menu:
      return menuActions.menuUpdateBlockDesign;
    case BLOCK_TYPES.podcast:
      return podcastActions.podcastUpdateBlockDesign;

    // ------------ Social media content ------------
    case BLOCK_TYPES.youtube:
      return youtubeUpdateBlockDesign;
    case BLOCK_TYPES.instagram:
      return instagramUpdateBlockDesign;
    case BLOCK_TYPES.tiktok:
      return tiktokUpdateBlockDesign;
    case BLOCK_TYPES.pageList:
      return pageListUpdateBlockDesing;

    // ------------ Growth tools ------------
    case BLOCK_TYPES.welcome:
      return welcomeUpdateBlockDesign;
    case BLOCK_TYPES.promo:
      return promoUpdateBlockDesign;
    case BLOCK_TYPES.review:
      return reviewUpdateBlockDesign;
    case BLOCK_TYPES.coupon:
      return couponUpdateBlockDesign;
    case BLOCK_TYPES.outfit:
      return outfitUpdateBlockDesign;
    case BLOCK_TYPES.timer:
      return timerUpdateBlockDesign;
    case BLOCK_TYPES.video:
      return videoUpdateBlockDesign;
    case BLOCK_TYPES.file:
      return fileUpdateDesign;
    case BLOCK_TYPES.pricing:
      return pricingUpdateBlockDesign;
    case BLOCK_TYPES.stat:
      return statsUpdateBlockDesign;
    default:
      return null;
  }
};
export const getActionUpdateBlockPreviewContent = (type) => {
  switch (type) {
    case BLOCK_TYPES.form:
      return formUpdateBlockPreviewContent;
    case BLOCK_TYPES.file:
      return fileUpdateBlockPreviewContent;
    case BLOCK_TYPES.stat:
      return statsUpdateBlockPreviewContent;
    case BLOCK_TYPES.faq:
      return faqUpdateBlockPreviewContent;
    default:
      return null;
  }
};

export const getActionUpdateBlockPreviewDesign = (type) => {
  switch (type) {
    case BLOCK_TYPES.form:
      return formUpdateBlockPreviewDesign;
    case BLOCK_TYPES.file:
      return fileUpdateBlockPreviewDesign;
    case BLOCK_TYPES.stat:
      return statsUpdateBlockPreviewDesign;
    case BLOCK_TYPES.faq:
      return faqUpdateBlockPreviewDesign;
    default:
      return null;
  }
};

export const getActionUpdateBlockSettings = (type) => {
  switch (type) {
    // ------------ Make and collect money ------------
    case BLOCK_TYPES.shop:
      return shopUpdateBlockSettings;

    case BLOCK_TYPES.appointment:
      return appointmentUpdateBlockSettings;

    case BLOCK_TYPES.donation:
    case BLOCK_TYPES.tips:
      return donationUpdateBlockSettings;

    case BLOCK_TYPES.promo:
      return promoUpdateBlockSettings;

    default:
      return null;
  }
};

export const getActionUpdateIsActive = (type) => {
  switch (type) {
    case BLOCK_TYPES.header:
      return headerUpdateIsActive;
    case BLOCK_TYPES.text:
      return textUpdateIsActive;
    case BLOCK_TYPES.links:
      return linksUpdateIsActive;
    case BLOCK_TYPES.dataCollect:
      return dataCollectUpdateIsActive;
    case BLOCK_TYPES.poll:
      return pollUpdateIsActive;
    case BLOCK_TYPES.apps:
      return appsUpdateIsActive;
    case BLOCK_TYPES.community:
      return communityUpdateIsActive;
    case BLOCK_TYPES.mediaKit:
      return mediaKitUpdateIsActive;
    case BLOCK_TYPES.form:
      return formUpdateIsActive;
    case BLOCK_TYPES.faq:
      return faqUpdateIsActive;
    case BLOCK_TYPES.recipe:
      return recipeUpdateIsActive;
    case BLOCK_TYPES.ama:
      return amaUpdateIsActive;
    case BLOCK_TYPES.wall:
      return guestbookUpdateIsActive;
    case BLOCK_TYPES.videoFeedback:
      return videoFeedbackUpdateIsActive;
    case BLOCK_TYPES.shoutout:
      return shoutoutUpdateIsActive;
    case BLOCK_TYPES.audioInbox:
      return audioInboxUpdateIsActive;
    case BLOCK_TYPES.status:
      return statusUpdateIsActive;
    case BLOCK_TYPES.crowdfunding:
      return crowdfundingUpdateIsActive;
    case BLOCK_TYPES.premiumInbox:
      return premiumInboxUpdateIsActive;
    case BLOCK_TYPES.livestream:
      return livestreamUpdateIsActive;
    case BLOCK_TYPES.workout:
      return workoutUpdateIsActive;
    case BLOCK_TYPES.features:
      return featuresUpdateIsActive;
    case BLOCK_TYPES.highlights:
      return highlightsUpdateIsActive;
    case BLOCK_TYPES.banner:
      return bannerUpdateIsActive;
    case BLOCK_TYPES.slider:
      return sliderUpdateIsActive;
    case BLOCK_TYPES.gallery:
      return galleryUpdateIsActive;
    case BLOCK_TYPES.blog:
      return blogUpdateIsActive;
    case BLOCK_TYPES.map:
      return mapUpdateIsActive;
    case BLOCK_TYPES.footer:
      return footerUpdateIsActive;
    case BLOCK_TYPES.chatAi:
      return chatUpdateIsActive;
    case BLOCK_TYPES.custom:
      return aiAppUpdateIsActive;

    // ------------ Make and collect money ------------
    case BLOCK_TYPES.digital:
      return digitalUpdateIsActive;
    case BLOCK_TYPES.appointment:
      return appointmentUpdateIsActive;
    case BLOCK_TYPES.shop:
      return shopUpdateIsActive;
    case BLOCK_TYPES.service:
      return serviceUpdateIsActive;
    case BLOCK_TYPES.trust:
      return trustUpdateIsActive;
    case BLOCK_TYPES.listing:
      return listingUpdateIsActive;
    case BLOCK_TYPES.overview:
      return overviewUpdateIsActive;
    case BLOCK_TYPES.rental:
      return rentalUpdateIsActive;
    case BLOCK_TYPES.singleProduct:
      return singleProductUpdateIsActive;
    case BLOCK_TYPES.team:
      return teamUpdateIsActive;
    case BLOCK_TYPES.timetable:
      return timetableUpdateIsActive;
    case BLOCK_TYPES.unlock:
      return unlockUpdateIsActive;
    case BLOCK_TYPES.donation:
    case BLOCK_TYPES.tips:
      return donationUpdateIsActive;
    case BLOCK_TYPES.course:
      return courseUpdateIsActive;
    case BLOCK_TYPES.event:
      return eventUpdateIsActive;
    case BLOCK_TYPES.timeline:
      return timelineUpdateIsActive;
    case BLOCK_TYPES.membership:
      return membershipUpdateIsActive;
    case BLOCK_TYPES.pricing:
      return pricingUpdateIsActive;
    case BLOCK_TYPES.booking:
      return bookingUpdateIsActive;
    case BLOCK_TYPES.nft:
      return nftUpdateIsActive;
    case BLOCK_TYPES.wallet:
      return walletUpdateIsActive;
    case BLOCK_TYPES.menu:
      return menuUpdateIsActive;

    // ------------ Social media content ------------
    case BLOCK_TYPES.youtube:
      return youtubeUpdateIsActive;
    case BLOCK_TYPES.instagram:
      return instagramUpdateIsActive;
    case BLOCK_TYPES.tiktok:
      return tiktokUpdateIsActive;
    case BLOCK_TYPES.twitter:
      return twitterUpdateIsActive;
    case BLOCK_TYPES.music:
      return musicUpdateIsActive;
    case BLOCK_TYPES.podcast:
      return podcastUpdateIsActive;
    case BLOCK_TYPES.twitch:
      return twitchUpdateIsActive;

    // ------------ Growth tools ------------
    case BLOCK_TYPES.splash:
      return splashUpdateIsActive;
    case BLOCK_TYPES.promo:
      return promoUpdateIsActive;
    case BLOCK_TYPES.welcome:
      return welcomeUpdateIsActive;
    case BLOCK_TYPES.review:
      return reviewUpdateIsActive;
    case BLOCK_TYPES.coupon:
      return couponUpdateIsActive;
    case BLOCK_TYPES.discount:
      return discountBlockUpdateIsActive;
    case BLOCK_TYPES.timer:
      return timerUpdateIsActive;
    case BLOCK_TYPES.outfit:
      return outfitUpdateIsActive;
    case BLOCK_TYPES.spacer:
      return spacerUpdateIsActive;
    case BLOCK_TYPES.html:
      return htmlUpdateIsActive;

    case BLOCK_TYPES.contacts:
      return contactsUpdateIsActive;

    case BLOCK_TYPES.video:
      return videoUpdateIsActive;
    case BLOCK_TYPES.file:
      return fileUpdateIsActive;
    case BLOCK_TYPES.stat:
      return statsUpdateIsActive;
    case BLOCK_TYPES.pageList:
      return pageListIsActive;

    default:
      return null;
  }
};

export const getActionUpdateIsLoading = (type) => {
  switch (type) {
    case BLOCK_TYPES.header:
      return headerUpdateIsLoading;
    case BLOCK_TYPES.text:
      return textUpdateIsLoading;
    case BLOCK_TYPES.links:
      return linksUpdateIsLoading;
    case BLOCK_TYPES.dataCollect:
      return dataCollectUpdateIsLoading;
    case BLOCK_TYPES.poll:
      return pollUpdateIsLoading;
    case BLOCK_TYPES.apps:
      return appsUpdateIsLoading;
    case BLOCK_TYPES.community:
      return communityUpdateIsLoading;
    case BLOCK_TYPES.mediaKit:
      return mediaKitUpdateIsLoading;
    case BLOCK_TYPES.form:
      return formUpdateIsLoading;
    case BLOCK_TYPES.contacts:
      return contactsUpdateIsLoading;
    case BLOCK_TYPES.faq:
      return faqUpdateIsLoading;
    case BLOCK_TYPES.recipe:
      return recipeUpdateIsLoading;
    case BLOCK_TYPES.ama:
      return amaUpdateIsLoading;
    case BLOCK_TYPES.wall:
      return guestbookUpdateIsLoading;
    case BLOCK_TYPES.videoFeedback:
      return videoFeedbackUpdateIsLoading;
    case BLOCK_TYPES.shoutout:
      return shoutoutUpdateIsLoading;
    case BLOCK_TYPES.audioInbox:
      return audioInboxUpdateIsLoading;
    case BLOCK_TYPES.status:
      return statusUpdateIsLoading;
    case BLOCK_TYPES.crowdfunding:
      return crowdfundingUpdateIsLoading;
    case BLOCK_TYPES.premiumInbox:
      return premiumInboxUpdateIsLoading;
    case BLOCK_TYPES.livestream:
      return livestreamUpdateIsLoading;
    case BLOCK_TYPES.workout:
      return workoutUpdateIsLoading;
    case BLOCK_TYPES.features:
      return featuresUpdateIsLoading;
    case BLOCK_TYPES.highlights:
      return highlightsUpdateIsLoading;
    case BLOCK_TYPES.banner:
      return bannerUpdateIsLoading;
    case BLOCK_TYPES.slider:
      return sliderUpdateIsLoading;
    case BLOCK_TYPES.gallery:
      return galleryUpdateIsLoading;
    case BLOCK_TYPES.blog:
      return blogUpdateIsLoading;
    case BLOCK_TYPES.map:
      return mapUpdateIsLoading;
    case BLOCK_TYPES.footer:
      return footerUpdateIsLoading;
    case BLOCK_TYPES.chatAi:
      return chatUpdateIsLoading;
    case BLOCK_TYPES.custom:
      return aiAppUpdateIsLoading;

    // ------------ Make and collect money ------------
    case BLOCK_TYPES.digital:
      return digitalUpdateIsLoading;
    case BLOCK_TYPES.appointment:
      return appointmentUpdateIsLoading;
    case BLOCK_TYPES.shop:
      return shopUpdateIsLoading;
    case BLOCK_TYPES.service:
      return serviceUpdateIsLoading;
    case BLOCK_TYPES.trust:
      return trustUpdateIsLoading;
    case BLOCK_TYPES.listing:
      return listingUpdateIsLoading;
    case BLOCK_TYPES.overview:
      return overviewUpdateIsLoading;
    case BLOCK_TYPES.rental:
      return rentalUpdateIsLoading;
    case BLOCK_TYPES.singleProduct:
      return singleProductUpdateIsLoading;
    case BLOCK_TYPES.team:
      return teamUpdateIsLoading;
    case BLOCK_TYPES.timetable:
      return timetableUpdateIsLoading;
    case BLOCK_TYPES.unlock:
      return unlockUpdateIsLoading;
    case BLOCK_TYPES.donation:
    case BLOCK_TYPES.tips:
      return donationUpdateIsLoading;
    case BLOCK_TYPES.course:
      return courseUpdateIsLoading;
    case BLOCK_TYPES.event:
      return eventUpdateIsLoading;
    case BLOCK_TYPES.timeline:
      return timelineUpdateIsLoading;
    case BLOCK_TYPES.membership:
      return membershipUpdateIsLoading;
    case BLOCK_TYPES.wallet:
      return walletUpdateIsLoading;
    case BLOCK_TYPES.nft:
      return nftUpdateIsLoading;
    case BLOCK_TYPES.pricing:
      return pricingUpdateIsLoading;
    case BLOCK_TYPES.booking:
      return bookingUpdateIsLoading;
    case BLOCK_TYPES.menu:
      return menuUpdateIsLoading;
    // ------------ Social media content ------------
    case BLOCK_TYPES.youtube:
      return youtubeUpdateIsLoading;
    case BLOCK_TYPES.tiktok:
      return tiktokUpdateIsLoading;
    case BLOCK_TYPES.instagram:
      return instagramUpdateIsLoading;
    case BLOCK_TYPES.twitter:
      return twitterUpdateIsLoading;
    case BLOCK_TYPES.music:
      return musicUpdateIsLoading;
    case BLOCK_TYPES.podcast:
      return podcastUpdateIsLoading;
    case BLOCK_TYPES.twitch:
      return twitchUpdateIsLoading;

    // ------------ Growth tools ------------
    case BLOCK_TYPES.splash:
      return splashUpdateIsLoading;
    case BLOCK_TYPES.promo:
      return promoUpdateIsLoading;
    case BLOCK_TYPES.welcome:
      return welcomeUpdateIsLoading;
    case BLOCK_TYPES.review:
      return reviewUpdateIsLoading;
    case BLOCK_TYPES.coupon:
      return couponUpdateIsLoading;
    case BLOCK_TYPES.discount:
      return discountBlockUpdateIsLoading;
    case BLOCK_TYPES.timer:
      return timerUpdateIsLoading;
    case BLOCK_TYPES.outfit:
      return outfitUpdateIsLoading;
    case BLOCK_TYPES.spacer:
      return spacerUpdateIsLoading;
    case BLOCK_TYPES.html:
      return htmlUpdateIsLoading;

    case BLOCK_TYPES.video:
      return videoUpdateIsLoading;
    case BLOCK_TYPES.file:
      return fileUpdateIsLoading;
    case BLOCK_TYPES.stat:
      return statsUpdateIsLoading;
    case BLOCK_TYPES.pageList:
      return pageListIsLoading;

    default:
      return commonUpdateIsLoadingStore;
  }
};

export const getSelectorBlockUID = (type) => {
  switch (type) {
    case BLOCK_TYPES.text:
      return selectTextUID;
    case BLOCK_TYPES.form:
      return selectFormUID;
    case BLOCK_TYPES.map:
      return selectMapUID;
    case BLOCK_TYPES.dataCollect:
      return selectDataCollectUID;
    case BLOCK_TYPES.poll:
      return selectPollUID;
    case BLOCK_TYPES.apps:
      return selectAppsUID;
    case BLOCK_TYPES.community:
      return selectCommunityUID;
    case BLOCK_TYPES.mediaKit:
      return selectMediaKitUID;
    case BLOCK_TYPES.gallery:
      return selectGalleryUID;
    case BLOCK_TYPES.contacts:
      return selectContactsUID;
    case BLOCK_TYPES.blog:
      return selectBlogUID;
    case BLOCK_TYPES.links:
      return selectLinksUID;
    case BLOCK_TYPES.chatAi:
      return selectChatUID;
    case BLOCK_TYPES.custom:
      return selectAiAppUID;

    case BLOCK_TYPES.shop:
    case 'external':
      return selectShopUID;
    case BLOCK_TYPES.digital:
      return selectDigitalUID;
    case BLOCK_TYPES.service:
      return selectServiceUID;
    case BLOCK_TYPES.trust:
      return selectTrustUID;
    case BLOCK_TYPES.listing:
      return selectListingUID;
    case BLOCK_TYPES.overview:
      return selectOverviewUID;
    case BLOCK_TYPES.rental:
      return selectRentalUID;
    case BLOCK_TYPES.singleProduct:
      return selectSingleProductUID;
    case BLOCK_TYPES.team:
      return selectTeamUID;
    case BLOCK_TYPES.timetable:
      return selectTimetableUID;
    case BLOCK_TYPES.unlock:
      return selectUnlockUID;
    case BLOCK_TYPES.coupon:
      return selectCouponUID;
    case BLOCK_TYPES.donation:
    case BLOCK_TYPES.tips:
      return selectDonationUID;
    case BLOCK_TYPES.membership:
      return selectMembershipUID;
    case BLOCK_TYPES.pricing:
      return selectPricingUID;
    case BLOCK_TYPES.wallet:
      return selectWalletUID;
    case BLOCK_TYPES.menu:
      return selectMenuUID;
    case BLOCK_TYPES.booking:
      return selectBookingUID;
    case BLOCK_TYPES.instagram:
      return selectInstagramUID;
    case BLOCK_TYPES.tiktok:
      return selectTikTokUID;
    case BLOCK_TYPES.youtube:
      return selectYouTubeUID;
    case BLOCK_TYPES.music:
      return selectMusicUID;
    case BLOCK_TYPES.podcast:
      return selectPodcastUID;

    case BLOCK_TYPES.appointment:
      return selectAppointmentUID;
    case BLOCK_TYPES.course:
      return selectCourseUID;
    case BLOCK_TYPES.event:
      return selectEventUID;
    case BLOCK_TYPES.timeline:
      return selectTimelineUID;
    case BLOCK_TYPES.outfit:
      return selectOutfitUID;

    case BLOCK_TYPES.video:
      return selectVideoUID;
    case BLOCK_TYPES.file:
      return selectFileUID;
    case BLOCK_TYPES.stat:
      return selectStatsUID;
    case BLOCK_TYPES.pageList:
      return selectPageListUID;
    default:
      return null;
  }
};

export const getSelectorBlockButtonDesign = (type) => {
  switch (type) {
    case BLOCK_TYPES.event:
      return selectEventButtonDesign;
    case BLOCK_TYPES.service:
      return selectServiceButtonDesign;
    default:
      return selectEventButtonDesign;
  }
};

export const getSelectorBlockItemDesign = (type) => {
  switch (type) {
    case BLOCK_TYPES.event:
      return selectEventItemDesign;
    case BLOCK_TYPES.service:
      return selectServiceItemDesign;
    default:
      return selectEventItemDesign;
  }
};

export const getSelectorBlockContent = (type) => {
  switch (type) {
    case BLOCK_TYPES.text:
      return selectTextBlockContent;
    case BLOCK_TYPES.form:
      return selectFormBlockContent;
    case BLOCK_TYPES.map:
      return selectMapBlockContent;
    case BLOCK_TYPES.dataCollect:
      return selectDataCollectBlockContent;
    case BLOCK_TYPES.poll:
      return selectPollBlockContent;
    case BLOCK_TYPES.apps:
      return selectAppsBlockContent;
    case BLOCK_TYPES.community:
      return selectCommunityBlockContent;
    case BLOCK_TYPES.mediaKit:
      return selectMediaKitBlockContent;
    case BLOCK_TYPES.gallery:
      return selectGalleryBlockContent;
    case BLOCK_TYPES.contacts:
      return selectContactsBlockContent;
    case BLOCK_TYPES.blog:
      return selectBlogBlockContent;
    case BLOCK_TYPES.links:
      return selectLinksBlockContent;
    case BLOCK_TYPES.chatAi:
      return selectChatBlockContent;
    case BLOCK_TYPES.custom:
      return selectAiAppBlockContent;

    case BLOCK_TYPES.shop:
    case 'external':
      return selectShopBlockContent;
    case BLOCK_TYPES.digital:
      return selectDigitalBlockContent;
    case BLOCK_TYPES.service:
      return selectServiceBlockContent;
    case BLOCK_TYPES.trust:
      return selectTrustBlockContent;
    case BLOCK_TYPES.listing:
      return selectListingBlockContent;
    case BLOCK_TYPES.overview:
      return selectOverviewBlockContent;
    case BLOCK_TYPES.rental:
      return selectRentalBlockContent;
    case BLOCK_TYPES.singleProduct:
      return selectSingleProductBlockContent;
    case BLOCK_TYPES.team:
      return selectTeamBlockContent;
    case BLOCK_TYPES.timetable:
      return selectTimetableBlockContent;
    case BLOCK_TYPES.unlock:
      return selectUnlockBlockContent;
    case BLOCK_TYPES.coupon:
      return selectCouponBlockContent;
    case BLOCK_TYPES.donation:
    case BLOCK_TYPES.tips:
      return selectDonationBlockContent;
    case BLOCK_TYPES.membership:
      return selectMembershipBlockContent;
    case BLOCK_TYPES.pricing:
      return selectPricingBlockContent;
    case BLOCK_TYPES.wallet:
      return selectWalletBlockContent;
    case BLOCK_TYPES.menu:
      return selectMenuBlockContent;
    case BLOCK_TYPES.booking:
      return selectBookingBlockContent;
    case BLOCK_TYPES.instagram:
      return selectInstagramBlockContent;
    case BLOCK_TYPES.tiktok:
      return selectTikTokBlockContent;
    case BLOCK_TYPES.youtube:
      return selectYouTubeBlockContent;
    case BLOCK_TYPES.music:
      return selectMusicBlockContent;
    case BLOCK_TYPES.podcast:
      return selectPodcastBlockContent;

    case BLOCK_TYPES.appointment:
      return selectAppointmentBlockContent;
    case BLOCK_TYPES.course:
      return selectCourseBlockContent;
    case BLOCK_TYPES.event:
      return selectEventBlockContent;
    case BLOCK_TYPES.timeline:
      return selectTimelineBlockContent;
    case BLOCK_TYPES.outfit:
      return selectOutfitBlockContent;

    case BLOCK_TYPES.video:
      return selectVideoBlockContent;

    case BLOCK_TYPES.file:
      return selectFileBlockContent;
    case BLOCK_TYPES.pageList:
      return selectPageListBlockContent;
    case BLOCK_TYPES.stat:
      return selectStatsBlockContent;
    default:
      return null;
  }
};

export const getSelectorBlockDesign = (type) => {
  switch (type) {
    // Both blocks have a blockDesign in their slice; the switch simply never listed them, so any
    // caller asking generically got null and their Design tab had nothing to read.
    case BLOCK_TYPES.faq:
      return selectFaqBlockDesign;
    case BLOCK_TYPES.features:
      return selectFeaturesBlockDesign;
    case BLOCK_TYPES.text:
      return selectTextContainerDesign;
    case BLOCK_TYPES.form:
      return selectFormBlockDesign;
    case BLOCK_TYPES.map:
      return selectMapBlockDesign;
    case BLOCK_TYPES.trust:
      return selectTrustBlockDesign;
    case BLOCK_TYPES.listing:
      return selectListingBlockDesign;
    case BLOCK_TYPES.overview:
      return selectOverviewBlockDesign;
    case BLOCK_TYPES.rental:
      return selectRentalBlockDesign;
    case BLOCK_TYPES.singleProduct:
      return selectSingleProductBlockDesign;
    case BLOCK_TYPES.team:
      return selectTeamBlockDesign;
    case BLOCK_TYPES.timetable:
      return selectTimetableBlockDesign;
    case BLOCK_TYPES.unlock:
      return selectUnlockBlockDesign;
    case BLOCK_TYPES.dataCollect:
      return selectDataCollectBlockDesign;
    case BLOCK_TYPES.poll:
      return selectPollBlockDesign;
    case BLOCK_TYPES.apps:
      return selectAppsBlockDesign;
    case BLOCK_TYPES.community:
      return selectCommunityBlockDesign;
    case BLOCK_TYPES.mediaKit:
      return selectMediaKitBlockDesign;
    case BLOCK_TYPES.gallery:
      return selectGalleryBlockDesign;
    case BLOCK_TYPES.contacts:
      return selectContactsBlockDesign;
    case BLOCK_TYPES.blog:
      return selectBlogBlockDesign;
    case BLOCK_TYPES.links:
      return selectLinksBlockDesign;
    case BLOCK_TYPES.chatAi:
      return selectChatBlockDesign;
    case BLOCK_TYPES.custom:
      return selectAiAppBlockDesign;

    case BLOCK_TYPES.shop:
      return selectShopBlockDesign;
    case BLOCK_TYPES.digital:
    case 'external':
      return selectDigitalBlockDesign;
    case BLOCK_TYPES.service:
      return selectServiceBlockDesign;
    case BLOCK_TYPES.coupon:
      return selectCouponBlockDesign;
    case BLOCK_TYPES.donation:
    case BLOCK_TYPES.tips:
      return selectDonationBlockDesign;
    case BLOCK_TYPES.membership:
      return selectMembershipBlockDesign;
    case BLOCK_TYPES.pricing:
      return selectPricingBlockDesign;
    case BLOCK_TYPES.wallet:
      return selectWalletBlockDesign;
    case BLOCK_TYPES.menu:
      return selectMenuBlockDesign;
    case BLOCK_TYPES.booking:
      return selectBookingBlockDesign;
    case BLOCK_TYPES.instagram:
      return selectInstagramBlockDesign;
    case BLOCK_TYPES.tiktok:
      return selectTikTokBlockDesign;
    case BLOCK_TYPES.youtube:
      return selectYouTubeBlockDesign;
    case BLOCK_TYPES.music:
      return selectMusicBlockDesign;
    case BLOCK_TYPES.podcast:
      return selectPodcastBlockDesign;

    case BLOCK_TYPES.appointment:
      return selectAppointmentBlockDesign;
    case BLOCK_TYPES.course:
      return selectCourseBlockDesign;
    case BLOCK_TYPES.event:
      return selectEventBlockDesign;
    case BLOCK_TYPES.timeline:
      return selectTimelineBlockDesign;
    case BLOCK_TYPES.outfit:
      return selectOutfitBlockDesign;

    case BLOCK_TYPES.video:
      return selectVideoBlockDesign;
    case BLOCK_TYPES.file:
      return selectFileBlockDesign;
    case BLOCK_TYPES.pageList:
      return selectPageListBlockContent;
    case BLOCK_TYPES.stat:
      return selectStatsBlockDesign;
    default:
      return null;
  }
};

export const getSelectorsBlock = (type) => {
  switch (type) {
    case BLOCK_TYPES.text:
      return { selectBlockId: selectTextId, selectBlockContent: selectTextBlockContent };
    case BLOCK_TYPES.links:
      return { selectBlockId: selectLinksId, selectBlockContent: selectLinksBlockContent };
    case BLOCK_TYPES.dataCollect:
      return { selectBlockId: selectDataCollectId, selectBlockContent: selectDataCollectBlockContent };
    case BLOCK_TYPES.poll:
      return { selectBlockId: selectPollId, selectBlockContent: selectPollBlockContent };
    case BLOCK_TYPES.apps:
      return { selectBlockId: selectAppsId, selectBlockContent: selectAppsBlockContent };
    case BLOCK_TYPES.community:
      return { selectBlockId: selectCommunityId, selectBlockContent: selectCommunityBlockContent };
    case BLOCK_TYPES.mediaKit:
      return { selectBlockId: selectMediaKitId, selectBlockContent: selectMediaKitBlockContent };
    case BLOCK_TYPES.form:
      return { selectBlockId: selectFormId, selectBlockContent: selectFormBlockContent, selectBlockPreviewContent: selectFormPreviewContent };
    case BLOCK_TYPES.faq:
      return { selectBlockId: selectFaqId, selectBlockContent: selectFaqBlockContent, selectBlockPreviewContent: selectFaqPreviewContent };
    case BLOCK_TYPES.recipe:
      return { selectBlockId: selectRecipeId, selectBlockContent: selectRecipeBlockContent };
    case BLOCK_TYPES.ama:
      return { selectBlockId: selectAmaId, selectBlockContent: selectAmaBlockContent };
    case BLOCK_TYPES.wall:
      return { selectBlockId: selectGuestbookId, selectBlockContent: selectGuestbookBlockContent };
    case BLOCK_TYPES.videoFeedback:
      return { selectBlockId: selectVideoFeedbackId, selectBlockContent: selectVideoFeedbackBlockContent };
    case BLOCK_TYPES.shoutout:
      return { selectBlockId: selectShoutoutId, selectBlockContent: selectShoutoutBlockContent };
    case BLOCK_TYPES.audioInbox:
      return { selectBlockId: selectAudioInboxId, selectBlockContent: selectAudioInboxBlockContent };
    case BLOCK_TYPES.status:
      return { selectBlockId: selectStatusId, selectBlockContent: selectStatusBlockContent };
    case BLOCK_TYPES.crowdfunding:
      return { selectBlockId: selectCrowdfundingId, selectBlockContent: selectCrowdfundingBlockContent };
    case BLOCK_TYPES.premiumInbox:
      return { selectBlockId: selectPremiumInboxId, selectBlockContent: selectPremiumInboxBlockContent };
    case BLOCK_TYPES.livestream:
      return { selectBlockId: selectLiveStreamId, selectBlockContent: selectLiveStreamBlockContent };
    case BLOCK_TYPES.workout:
      return { selectBlockId: selectWorkoutId, selectBlockContent: selectWorkoutBlockContent };
    case BLOCK_TYPES.features:
      return { selectBlockId: selectFeaturesId, selectBlockContent: selectFeaturesBlockContent };
    case BLOCK_TYPES.highlights:
      return { selectBlockId: selectHighlightsId, selectBlockContent: selectHighlightsBlockContent };
    case BLOCK_TYPES.banner:
      return { selectBlockId: selectBannerId, selectBlockContent: selectBannerBlockContent };
    case BLOCK_TYPES.slider:
      return { selectBlockId: selectSliderId, selectBlockContent: selectSliderBlockContent };
    case BLOCK_TYPES.gallery:
      return { selectBlockId: selectGalleryId, selectBlockContent: selectGalleryBlockContent };
    case BLOCK_TYPES.blog:
      return { selectBlockId: selectBlogId, selectBlockContent: selectBlogBlockContent };
    case BLOCK_TYPES.contacts:
      return { selectBlockId: selectContactsId, selectBlockContent: selectContactsBlockContent };
    case BLOCK_TYPES.map:
      return { selectBlockId: selectMapId, selectBlockContent: selectMapBlockContent };
    case BLOCK_TYPES.footer:
      return { selectBlockId: selectFooterId, selectBlockContent: selectFooterBlockContent };
    case BLOCK_TYPES.chatAi:
      return { selectBlockId: selectChatId, selectBlockContent: selectChatBlockContent };
    case BLOCK_TYPES.custom:
      return { selectBlockId: selectAiAppId, selectBlockContent: selectAiAppBlockContent };

    // ------------ Make and collect money ------------
    case BLOCK_TYPES.shop:
      return { selectBlockId: selectShopId, selectBlockContent: selectShopBlockContent };
    case BLOCK_TYPES.digital:
      return { selectBlockId: selectDigitalId, selectBlockContent: selectDigitalBlockContent };
    case BLOCK_TYPES.appointment:
      return { selectBlockId: selectAppointmentId, selectBlockContent: selectAppointmentBlockContent };
    case BLOCK_TYPES.service:
      return { selectBlockId: selectServiceId, selectBlockContent: selectServiceBlockContent };
    case BLOCK_TYPES.trust:
      return { selectBlockId: selectTrustId, selectBlockContent: selectTrustBlockContent };
    case BLOCK_TYPES.listing:
      return { selectBlockId: selectListingId, selectBlockContent: selectListingBlockContent };
    case BLOCK_TYPES.overview:
      return { selectBlockId: selectOverviewId, selectBlockContent: selectOverviewBlockContent };
    case BLOCK_TYPES.rental:
      return { selectBlockId: selectRentalId, selectBlockContent: selectRentalBlockContent };
    case BLOCK_TYPES.singleProduct:
      return { selectBlockId: selectSingleProductId, selectBlockContent: selectSingleProductBlockContent };
    case BLOCK_TYPES.team:
      return { selectBlockId: selectTeamId, selectBlockContent: selectTeamBlockContent };
    case BLOCK_TYPES.timetable:
      return { selectBlockId: selectTimetableId, selectBlockContent: selectTimetableBlockContent };
    case BLOCK_TYPES.unlock:
      return { selectBlockId: selectUnlockId, selectBlockContent: selectUnlockBlockContent };
    case BLOCK_TYPES.donation:
    case BLOCK_TYPES.tips:
      return { selectBlockId: selectDonationId, selectBlockContent: selectDonationBlockContent };
    case BLOCK_TYPES.course:
      return { selectBlockId: selectCourseId, selectBlockContent: selectCourseBlockContent };
    case BLOCK_TYPES.event:
      return { selectBlockId: selectEventId, selectBlockContent: selectEventBlockContent };
    case BLOCK_TYPES.timeline:
      return { selectBlockId: selectTimelineId, selectBlockContent: selectTimelineBlockContent };
    case BLOCK_TYPES.membership:
      return { selectBlockId: selectMembershipId, selectBlockContent: selectMembershipBlockContent };
    case BLOCK_TYPES.pricing:
      return { selectBlockId: selectPricingId, selectBlockContent: selectPricingBlockContent };
    case BLOCK_TYPES.nft:
      return { selectBlockId: selectNftId, selectBlockContent: selectNftBlockContent };
    case BLOCK_TYPES.wallet:
      return { selectBlockId: selectWalletId, selectBlockContent: selectWalletBlockContent };
    case BLOCK_TYPES.menu:
      return { selectBlockId: selectMenuId, selectBlockContent: selectMenuBlockContent };
    case BLOCK_TYPES.booking:
      return { selectBlockId: selectBookingId, selectBlockContent: selectBookingBlockContent };
    // ------------ Social media content ------------
    case BLOCK_TYPES.youtube:
      return { selectBlockId: selectYouTubeId, selectBlockContent: selectYouTubeBlockContent };
    case BLOCK_TYPES.instagram:
      return { selectBlockId: selectInstagramId, selectBlockContent: selectInstagramBlockContent };
    case BLOCK_TYPES.tiktok:
      return { selectBlockId: selectTikTokId, selectBlockContent: selectTikTokBlockContent };
    case BLOCK_TYPES.twitter:
      return { selectBlockId: selectTwitterId, selectBlockContent: selectTwitterBlockContent };
    case BLOCK_TYPES.music:
      return { selectBlockId: selectMusicId, selectBlockContent: selectMusicBlockContent };
    case BLOCK_TYPES.podcast:
      return { selectBlockId: selectPodcastId, selectBlockContent: selectPodcastBlockContent };
    case BLOCK_TYPES.twitch:
      return { selectBlockId: selectTwitchId, selectBlockContent: selectTwitchBlockContent };

    // ------------ Growth tools ------------
    case BLOCK_TYPES.splash:
      return { selectBlockId: selectSplashId, selectBlockContent: selectSplashBlockContent };
    case BLOCK_TYPES.promo:
      return { selectBlockId: selectPromoId, selectBlockContent: selectPromoBlockContent };
    case BLOCK_TYPES.welcome:
      return { selectBlockId: selectWelcomeId, selectBlockContent: selectWelcomeBlockContent };
    case BLOCK_TYPES.review:
      return { selectBlockId: selectReviewId, selectBlockContent: selectReviewBlockContent };
    case BLOCK_TYPES.coupon:
      return { selectBlockId: selectCouponId, selectBlockContent: selectCouponBlockContent };
    case BLOCK_TYPES.discount:
      return { selectBlockId: selectDiscountBlockId, selectBlockContent: selectDiscountBlockContent };
    case BLOCK_TYPES.timer:
      return { selectBlockId: selectTimerId, selectBlockContent: selectTimerBlockContent };
    case BLOCK_TYPES.outfit:
      return { selectBlockId: selectOutfitId, selectBlockContent: selectOutfitBlockContent };
    case BLOCK_TYPES.spacer:
      return { selectBlockId: selectSpacerId, selectBlockContent: selectSpacerBlockContent };
    case BLOCK_TYPES.html:
      return { selectBlockId: selectHTMLId, selectBlockContent: selectHTMLBlockContent };

    case BLOCK_TYPES.video:
      return { selectBlockId: selectVideoId, selectBlockContent: selectVideoBlockContent };
    case BLOCK_TYPES.file:
      return { selectBlockId: selectFileId, selectBlockContent: selectFileBlockContent, selectBlockPreviewContent: selectFilePreviewContent };
    case BLOCK_TYPES.stat:
      return { selectBlockId: selectStatsId, selectBlockContent: selectStatsBlockContent, selectBlockPreviewContent: selectStatsPreviewContent };
    case BLOCK_TYPES.pageList:
      return { selectBlockId: selectPageListId, selectBlockContent: selectPageListBlockContent };
    default:
      return null;
  }
};

export const updateItem = (activeId, newItem, list, setList, setActiveItem = () => {}) => {
  const updatedItems = list.map((el) => {
    const { id } = el;
    if (id === activeId) {
      setActiveItem({ ...el, ...newItem });
      return {
        ...el,
        ...newItem,
      };
    }

    return el;
  });
  setList(updatedItems);
};

export const deleteItem = (id, list, setList) => {
  const updatedItems = Array.isArray(list) ? list.filter((el) => el.id !== id) : [];
  setList(updatedItems);
};

export const getHeadingFields = (blockContent) => {
  if (Object.prototype.hasOwnProperty.call(blockContent, 'heading')) {
    const {
      title,
      description,
      textAlign,
      image,
      divider,
      position,
      layout,
      label,
      labelColor,
      labelBackgroundColor,
      labelFontSize,
      labelAlign,
      labelShape,
      labelIsGradient,
      labelGradientColor,
      labelUrl,
    } = blockContent.heading;
    return {
      title,
      description,
      textAlign,
      image,
      divider,
      position,
      layout,
      label,
      labelColor,
      labelBackgroundColor,
      labelFontSize,
      labelAlign,
      labelShape,
      labelIsGradient,
      labelGradientColor,
      labelUrl,
    };
  }

  return {};
};
export const getPreviewFields = (blockPreview) => {
  if (!blockPreview) return {};

  return {
    thumbnail: blockPreview.thumbnail,
    isActive: blockPreview.isActive,
    view: blockPreview.view,
    title: blockPreview.title,
    description: blockPreview.description,
    button: blockPreview.button,
    label: blockPreview.label,
    timeStart: blockPreview.timeStart,
  };
};

export const getApiPathBlock = (type) => {
  switch (type) {
    case BLOCK_TYPES.features:
      return 'feature';
    case BLOCK_TYPES.highlights:
      return 'highlight';
    case BLOCK_TYPES.livestream:
      // Controller route is api/livestream-blocks/{id} (no hyphen), but type is 'live-stream'.
      return 'livestream';
    default:
      return type;
  }
};

export const getContentFields = (blockContent) => {
  const data = { ...blockContent };
  if (Object.prototype.hasOwnProperty.call(data, 'items')) {
    delete data.items;
  }

  if (Object.prototype.hasOwnProperty.call(data, 'options')) {
    delete data.options;
  }

  if (Object.prototype.hasOwnProperty.call(data, 'heading')) {
    delete data.heading;
  }

  if (Object.prototype.hasOwnProperty.call(data, 'cta')) {
    delete data.cta;
  }

  return data;
};
